import React, { useEffect, useState } from "react";
import { fetchAutonomo } from "screens/perfilAutonomo/api/getAutonomo";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { Loading } from "screens/perfilAutonomo/components/Loading";
import * as S from "./style";
import { ButtonMenu } from "../components/ButtonMenu/buttonMenu.component";
import { RevendaMenusC, RevendaMenusE, RevendaMenuComponents } from "../utils";

export const RevendaComponent = () => {
  const [activeMenu, setActiveMenu] = useState(RevendaMenusE.empreendimento);

  const { username } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { data: user, isLoading } = fetchAutonomo(username);

  useEffect(() => {
    if (
      user &&
      user?.userAdResponse?.token &&
      !localStorage.getItem("conexaoToken")
    )
      localStorage.setItem("conexaoToken", user?.userAdResponse?.token);
  }, [user]);

  const authToken = user?.userAdResponse?.token;

  const ActiveComponent = RevendaMenuComponents[activeMenu];

  return (
    <S.OuterContainer>
      <S.Container>
        <S.MenuButtons>
          {RevendaMenusC.map((menu) => (
            <ButtonMenu
              key={menu.id}
              icon={menu.icon}
              content={menu.content}
              isSelected={activeMenu === menu.isSelected}
              onClick={() => setActiveMenu(menu.isSelected)}
            />
          ))}
        </S.MenuButtons>
      </S.Container>
      <S.Container>
        {isLoading ? <Loading /> : <ActiveComponent authToken={authToken} />}
      </S.Container>
    </S.OuterContainer>
  );
};
